module.exports = __webpack_public_path__ + "img/lively temple grounds.ed0160a5.png";